import { GET_ORDER, GET_STORE, GET_SINGLE_ORDER} from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_ORDER:
            return action.payload;
        case GET_STORE:
            return action.payload;
        case GET_SINGLE_ORDER:
            return action.payload;
        default:
            return state;
    }
}